import { MtAccount } from "server/models"
import { ActiveInactive, OrderType } from "client/utils"


export interface AccountProps {
    accountId: number
    hash?: string
}

export interface AccountList { [accountId: number]: MtAccount }
export interface AccountFilters {
    packageExpired?: boolean
    packageAlmostExpired?: boolean
    status?: ActiveInactive
    search?: string
}

export type AccountValidation = { [key in keyof MtAccount]?: string}

export interface AccountState {
    accountList: AccountList
    accountIds: readonly number[]
    accountView: MtAccount
    accountEdit: MtAccount

    sortColumn: keyof MtAccount
    sortOrder: OrderType
    filters: AccountFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const ACCOUNT_LIST = "ACCOUNT_LIST"
export const ACCOUNT_IDS = "ACCOUNT_IDS"
export const ACCOUNT_VIEW = "ACCOUNT_VIEW"
export const ACCOUNT_EDIT = "ACCOUNT_EDIT"

export const ACCOUNT_SORT = "ACCOUNT_SORT"
export const ACCOUNT_FILTERS = "ACCOUNT_FILTERS"

export const ACCOUNT_RELOAD_LIST = "ACCOUNT_RELOAD_LIST"
export const ACCOUNT_RELOAD_VIEW = "ACCOUNT_RELOAD_VIEW"
export const ACCOUNT_RELOAD_EDIT = "ACCOUNT_RELOAD_EDIT"
